import { CreateBoard, CreateBoardVariables } from './__generated__/CreateBoard'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation CreateBoard($input: CreateBoardInput!) {
    createBoard(input: $input) {
      created
      board {
        id
        title
      }
    }
  }
`

export const useCreateBoard = () => {
  return useMutation<CreateBoard, CreateBoardVariables>(MUTATION)
}
